// Single source of truth for the external Etsy shop URL.
// All Etsy purchase links across the site (ShopPage, CoursePage) import from here so the
// URL can be updated once when the Etsy shop name is confirmed.
//
// TODO: replace the placeholder with the actual Etsy shop URL once confirmed.
export const ETSY_SHOP_URL = 'https://www.etsy.com/shop/RecalibrateShop';

// Per-product Etsy listing URLs (fallback to ETSY_SHOP_URL when listing not yet confirmed).
export const ETSY_LISTINGS = {
  'recalibrate-101': 'https://www.etsy.com/listing/4401786496/chronic-pain-course-self-management-101',
  'calming-nervous-system-ebook': 'https://recalibrateshop.etsy.com/listing/4496446585',
  'pocket-flashcards-vol-1': 'https://recalibrateshop.etsy.com/listing/4496808261',
  '30-day-nervous-system-reset': 'https://recalibrateshop.etsy.com/listing/4498451999',
};

// Helper used by ShopPage + CoursePage to render purchase channels per product.
// Returns an array of { channel, label, url, primary } in display order.
//
// On-site (Stripe) purchase is intentionally disabled for now while the product
// catalog is being finalised. All purchases route to Etsy. When site-direct is
// re-enabled later, restore the SITE_PURCHASE map and add the 'site' channel
// back into the returned array.
export function getProductChannels(productId) {
  const etsy = ETSY_LISTINGS[productId] || ETSY_SHOP_URL;
  return [
    {
      channel: 'etsy',
      label: 'Buy on Etsy',
      url: etsy,
      enabled: true,
      primary: true,
    },
  ];
}
